import { render } from "./ComentUserCard.vue?vue&type=template&id=1b122bba&scoped=true"
import script from "./ComentUserCard.vue?vue&type=script&lang=js"
export * from "./ComentUserCard.vue?vue&type=script&lang=js"

import "./ComentUserCard.vue?vue&type=style&index=0&id=1b122bba&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b122bba"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QImg,QBtn,QMenu,QList,QItem,QItemSection,QIcon});qInstall(script, 'directives', {ClosePopup});
